import { recordLiveAppInteraction } from "../../world-model/liveAppPerception";

export const MAXX_PLAYBACK_REQUEST_EVENT = "neo-maxx-playback-request";
export const MAXX_PLAYBACK_STATE_EVENT = "neo-maxx-playback-state";

export function normalizeMaxxPlaybackAction(action) {
  const normalized = String(action || "").trim().toLowerCase();
  if (["pause", "stop", "pause_neurons", "n2x_pause"].includes(normalized)) return "pause";
  if (["play", "resume", "continue", "start", "resume_neurons", "n2x_resume"].includes(normalized)) return "resume";
  return null;
}

export function readMaxxPlaybackStatus(state) {
  const clips = Array.isArray(state?.clips) ? state.clips : [];
  if (state?.active !== true || clips.length === 0) return null;

  return {
    paused: clips.every((clip) => clip?.paused === true),
    neurodesignVisible: state?.neurodesignVisible === true,
  };
}

export function requestMaxxPlayback(action, { source = "interface" } = {}) {
  const normalizedAction = normalizeMaxxPlaybackAction(action);
  if (!normalizedAction || typeof window === "undefined") return false;

  recordLiveAppInteraction(
    normalizedAction === "pause" ? "pause_neurons" : "resume_neurons",
    "maxx_neurons",
    { portal: "maxx" }
  );

  window.dispatchEvent(new CustomEvent(MAXX_PLAYBACK_REQUEST_EVENT, {
    detail: {
      action: normalizedAction,
      source: String(source || "interface"),
    },
  }));

  const currentState = window.__maxxAnimationState;
  if (currentState?.active === true && Array.isArray(currentState.clips)) {
    const paused = normalizedAction === "pause";
    publishMaxxPlaybackState({
      ...currentState,
      observedAt: new Date().toISOString(),
      neurodesignVisible: paused,
      clips: currentState.clips.map((clip) => ({
        ...clip,
        paused,
      })),
    });
  }
  return true;
}

export function controlMaxxPlayback(command, value = null) {
  if (
    typeof window === "undefined" ||
    typeof window.__maxxAnimationControl !== "function"
  ) {
    return false;
  }

  const controlled = window.__maxxAnimationControl(command, value);
  if (controlled && command === "restart") {
    recordLiveAppInteraction("restart_playback", "neuron_animation", { portal: "maxx" });
  }
  if (controlled && (command === "seek_progress" || command === "scrub_progress")) {
    recordLiveAppInteraction(
      "scrub_playback",
      `${Math.round(Math.max(0, Math.min(1, Number(value) || 0)) * 100)}%`,
      { portal: "maxx" }
    );
  }
  return controlled;
}

export function publishMaxxPlaybackState(state) {
  if (typeof window === "undefined") return false;

  if (state) window.__maxxAnimationState = state;
  else delete window.__maxxAnimationState;

  window.dispatchEvent(new CustomEvent(MAXX_PLAYBACK_STATE_EVENT, {
    detail: state || null,
  }));
  return true;
}
